export const departmentConsts = {
  DineIn: "SYS01",
  TakeAway: "SYS02",
  Delivery: "SYS03",
};

export const preInvoiceSources = [
  { label: "None", value: "0", key: 0 },
  { label: "Main Call Center", value: "1", key: 1 },
  { label: "Mobile App", value: "2", key: 2 },
  { label: "Web Portal", value: "3", key: 3 },
];

export const signalREventNames = {
  WorkPeriodUpdated: "app.information.workPeriodUpdated",
  InvoiceUpdated: "app.information.invoiceUpdated",
  OnlineOrderReceived: "app.information.onlineOrderReceived",
  OnlineOrderUpdated: "app.information.onlineOrderUpdated",
  Message: "app.information.message",
  ErrorMessage: "app.information.errorMessage",
  OnlineOrderReceivedRefresh: "app.information.onlineOrderReceivedRefresh",
  IncomingCall: "app.information.incomingCall",
};

export const months = [
  { value: 1, label: "Jan" },
  { value: 2, label: "Feb" },
  { value: 3, label: "Mar" },
  { value: 4, label: "Apr" },
  { value: 5, label: "May" },
  { value: 6, label: "Jun" },
  { value: 7, label: "Jul" },
  { value: 8, label: "Aug" },
  { value: 9, label: "Sep" },
  { value: 10, label: "Oct" },
  { value: 11, label: "Nov" },
  { value: 12, label: "Dec" },
];

export const Customer = "0001";
export const Rider = "0002";
export const StateGroupStatus = "0001";
export const StateGroupDeliveryStatus = "0002";
export const tenantStateAcitve = 1;
export const tenantStateInAcitve = 2;
export const tenantStateNotFound = 3;
export const tenantStateOffline = 4;
